//
// FIXME: This is not a React component, so the file should end in .ts, not .tsx.
//

import angular from 'angular';
import type { CartOrder, CartOrderManager } from 'cart-core';
import { getContentArea } from 'cart-core';
import { getSessionSponsorRcn } from 'sponsor-rcn-affiliate-links';
import SignUpAngularController from '../SignUpAngularController';

interface SelectOption {
  key: number | string;
  value: string;
}

interface Response {
  messages: unknown;
}

const messageNamespace = 'checkoutDistributor';

class CheckoutDistributorController extends SignUpAngularController {
  public fieldMessages: {};
  public genderOptions: SelectOption[];
  public hasMessage: boolean;
  public myPage: string;
  public passwordAgain: string;
  public profitLevel: string;
  public profitLevelString: string;
  public showForm: boolean;
  public sponsorRcnAgain: string;
  /** @todo Unused? */
  public termsConditions: unknown;
  public disclaimerMessage = this.$sce.trustAsHtml(getContentArea('checkoutDistributorDisclaimer') || '');

  constructor(
    private $sce: angular.ISCEService,
    private $location: angular.ILocationService,
    private $routeParams: any,
    private translateFilter: any,
    private orderMgr: CartOrderManager,
    private checkoutEnrollment: any,
    private termsDialog: any
  ) {
    super();

    this.order = orderMgr.getOrder();
    this.showForm = true;
    this.myPage = '/checkout/distributor';
    this.hasMessage = false;
    this.fieldMessages = {};
    this.genderOptions = [
      {
        key: 0,
        value: this.translateFilter('Female'),
      },
      {
        key: 1,
        value: this.translateFilter('Male'),
      },
    ];
    this.profitLevelString = this.translateFilter('Profit Level');
    /** @todo Unused? */
    this.termsConditions = null;
    this.haveSponsor = true;

    /**
     * on orderMgr.orderChange
     */
    orderMgr.getEventManager().on('orderMgr.orderChange', this.updateOrder, 'checkoutDistributor');

    // Only refresh if no order
    if (!this.orderMgr.hasOrder()) {
      this.orderMgr.refreshOrder();
    } else {
      this.updateOrder(this.orderMgr.getOrder());
    }
  }

  public shouldShowProfilePrimaryFields() {
    return !!this.order?.attributes && this.order.attributes.signUpRules.distributor.type !== 'customer-to-distributor';
  }

  public shouldShowSponsorRcn() {
    return (
      !!this.order?.attributes &&
      !this.order.attributes.signUpRules.distributor.requiredSponsorRcn &&
      this.haveSponsor !== false
    );
  }

  public shouldCreateNewAccountRatherThanConvert = () => {
    return this.order?.attributes.signUpRules.distributor.type === 'new-distributor';
  };

  public handleHaveSponsorChanged = (value) => {
    if (value) {
      this.newProfile.sponsorRcn = '';
      this.sponsorRcnAgain = '';
    } else {
      this.newProfile.sponsorRcn = this.order.attributes.guestSignUpRules.sponsorRcn;
      this.sponsorRcnAgain = this.order.attributes.guestSignUpRules.sponsorRcn;
    }
  };

  public submit = () => {
    this.onSubmit();

    if (this.shouldCreateNewAccountRatherThanConvert()) {
      if (!this.verifySponsorRcn()) {
        return;
      }

      if (!this.verifyPassword()) {
        return;
      }

      this.checkoutEnrollment.createTempProfile(this.newProfile, this.onSubmitSuccess, this.onSubmitError);
      return;
    }

    this.checkoutEnrollment.updateTempProfile(this.newProfile, this.onSubmitSuccess, this.onSubmitError);
  };

  public onSubmit = () => {
    this.hasMessage = false;
    this.checkoutEnrollment.clearMessages(messageNamespace);
  };

  public onSubmitSuccess = async () => {
    this.showForm = false;
    try {
      const response = await this.orderMgr.refreshOrder(this.orderMgr.loadingListener);
      this.order = response.data;
      this.orderMgr.nextPage(false);
    } catch (response) {
      this.onSubmitError(response);
      if (response instanceof Error) {
        throw response;
      }
    }
  };

  public onSubmitError = (response: any) => {
    this.checkoutEnrollment.handleMessages(
      response.messages,
      this.setFieldMessages,
      this.onPrimaryMessage,
      messageNamespace
    );
  };

  public setFieldMessages = (messages) => {
    this.fieldMessages = messages;
  };

  public onPrimaryMessage = (messages) => {
    this.hasMessage = true;
  };

  public isMyPage = () => {
    return this.$location.path() === this.myPage;
  };

  public showTerms = () => {
    this.termsDialog.showTerms('newDistributor', this.order, this.newProfile, this.checkoutEnrollment.handleMessages);
  };

  public initOrder = () => {
    if (this.order.attributes.signUpRules.distributor.type === 'customer-to-distributor') {
      this.newProfile = this.order.attributes.currentUserRules.profile;
      this.newProfile.sponsorRcn = this.order.attributes.currentUserRules.profile.sponsorRcn;

      // clear email
      this.newProfile.email = null;
      // clear username
      this.newProfile.username = null;
      // clear password
      this.newProfile.password = null;
    }

    // This is the Distributor page, set status
    this.newProfile.status = 'D';
    this.newProfile.rank = '1';

    // Must accept terms
    this.newProfile.acceptedTerms = 0;

    // get sponsorRcn from affiliate link system if it is set
    this.newProfile.sponsorRcn = getSessionSponsorRcn();

    // get rank from query if set
    if (this.$routeParams.rank) {
      this.newProfile.rank = this.$routeParams.rank.toString();
      // if set from url, is only on available?
      const availableDistributorRanksDetails = [];
      angular.forEach(this.order.attributes.rankRules.availableDistributorRanksDetails, (value, key) => {
        if (value.rank === this.newProfile.rank) {
          availableDistributorRanksDetails.push(value);
        }
      });
      this.order.attributes.rankRules.availableDistributorRanksDetails = availableDistributorRanksDetails;
    }
    if (!this.newProfile.rank) {
      this.newProfile.rank = this.order.attributes.rankRules.defaultRankDistributor;
    }

    // set genders
    if (!this.newProfile.primaryGenderIsMale) {
      this.newProfile.primaryGenderIsMale = 0;
    }

    if (!this.newProfile.secondaryGenderIsMale) {
      this.newProfile.secondaryGenderIsMale = 0;
    }

    /**
     * Populate the sponsor RCN with the required RCN if an RCN is required
     */
    if (this.order.attributes.signUpRules.distributor.requiredSponsorRcn) {
      this.newProfile.sponsorRcn = this.order.attributes.signUpRules.distributor.requiredSponsorRcn;
    }

    // Sync again field always
    this.sponsorRcnAgain = this.newProfile.sponsorRcn;

    // Set creationMethod
    this.newProfile.creationMethod = 'Distributor';

    if (this.order.attributes.currentUserRules.loggedIn && this.order.attributes.currentUserRules.profile.isCustomer) {
      this.newProfile.creationMethod = 'CustomerToDistributor';
    }

    /* Might be needed later
        handleMessage(
        {
        level: 'info',
        value: translateFilter('After completing this page, the sponsoring '
            + 'Distributor will be logged out in order for the new applicant to complete the application process.')
        }
        );
        */
    this.showForm = true;
  };

  public updateOrder = (order: CartOrder) => {
    this.order = order;
    if (this.isMyPage()) {
      this.initOrder();
    }
  };
}

angular
  .module('checkout')
  .controller('checkoutDistributor', [
    '$sce',
    '$location',
    '$routeParams',
    'translateFilter',
    'orderMgr',
    'checkoutEnrollment',
    'termsDialog',
    CheckoutDistributorController as any,
  ]);
